module.exports = __webpack_public_path__ + "img/banner.ff08edec.png";